import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import * as fromAuthorize from "./reducers";
import { SharedModule } from "../shared/shared.module";
import { EffectsModule } from "@ngrx/effects";
import { AuthorizeEffects } from "./effects/authorize.effects";
import { StoreModule } from "@ngrx/store";

@NgModule({
  imports: [
    SharedModule, 
    StoreModule.forFeature(
      fromAuthorize.authorizeFeatureKey,
      fromAuthorize.reducers
    ),
    EffectsModule.forFeature([
      AuthorizeEffects
    ])
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AuthorizeModule { }